// authSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { stopGlobalAudio } from "../utils/audioManager";

interface AuthState {
  isAuthenticated: boolean;
  lastActivity: number;
  portal: string | null;
  meetingDetailsNirnany: any | null;
  uploadConsent: boolean;
  token: {
    access_token: string;
    token_type: string;
  } | null;
}

const initialState: AuthState = {
  isAuthenticated: !!localStorage.getItem("loginDetails"),
  lastActivity: 0,
  portal: localStorage.getItem("portal"),
  meetingDetailsNirnany: localStorage.getItem("meetingDetailsNirnany")
    ? JSON.parse(localStorage.getItem("meetingDetailsNirnany")!)
    : null,
  uploadConsent: localStorage.getItem("uploadConsent") === "true",
  token: localStorage.getItem("authToken")
    ? JSON.parse(localStorage.getItem("authToken")!)
    : null,
};


const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(
      state,
      action: {
        payload: {
          portal: string;
          meetingDetailsNirnany?: any;
          token?: {
            access_token: string;
            token_type: string;
          };
        };
      }
    ) {
      state.isAuthenticated = true;
      state.lastActivity = Date.now();
      state.portal = action.payload.portal;

      if (action.payload.meetingDetailsNirnany) {
        state.meetingDetailsNirnany = action.payload.meetingDetailsNirnany;
      }

      if (action.payload.token) {
        state.token = action.payload.token;
        localStorage.setItem(
          "authToken",
          JSON.stringify(action.payload.token)
        );
      }
    },

    logout(state) {
      state.isAuthenticated = false;
      state.lastActivity = 0;
      state.portal = null;
      state.meetingDetailsNirnany = null;
      state.uploadConsent = false;
      state.token = null;

      localStorage.removeItem("loginDetails");
      localStorage.removeItem("uploadConsent");
      localStorage.removeItem("portal");
      localStorage.removeItem("meetingDetailsNirnany");
      localStorage.removeItem("authToken");
       stopGlobalAudio();
    },

    refreshActivity(state) {
      state.lastActivity = Date.now();
    },
  },
});

export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;

export const { login, logout, refreshActivity } = authSlice.actions;
export default authSlice.reducer;
